<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">权限设置</span></div>
		<div class="margin-top margin-left">
			<Button color="primary" @click="openAdd">新增</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="datas" :border="true">
				<TableItem title="用户" prop="realName"></TableItem>
				<TableItem title="手机号" prop="mobile"></TableItem>
				<TableItem title="角色">
					<template slot-scope="{data}">{{roleName(data.role)}}</template>
				</TableItem>
				<TableItem>
					<div class="actions" slot-scope="{data}">
						<span @click="showHandOver=true" v-if="currentAccountSets.creatorId == data.id && data.id == User.id">移交</span>
						<template v-else-if="User.id != data.id && currentAccountSets.creatorId != data.id">
							<span @click="edit(data)">编辑</span>
							<span @click="remove(data)">删除</span>
						</template>
					</div>
				</TableItem>
			</Table>
		</div>

		<!-- 新增员工 -->
		<Modal v-model="showForm" :width="620" hasCloseIcon>
			<div slot="header">{{form.id ? '编辑员工' : '新增员工'}}</div>
			<div class="emp-form">
				<div class="emp-label">*员工</div>
				<input list="employeeOptions" class="emp-input" v-model="form.mobile" :disabled="!!form.id"
					   placeholder="选择已有员工或输入新员工手机号码">
				<datalist id="employeeOptions">
					<option v-for="e in employeeCandidates" :key="e.id" :value="e.mobile">{{e.realName}}</option>
				</datalist>

				<div class="emp-label emp-role-label">角色</div>
				<div class="role-cards">
					<div v-for="r in roleCards" :key="r.code" class="role-card"
						 :class="{'role-card-on': form.role === r.code}" @click="form.role = r.code">
						<span class="role-radio">
							<i v-if="form.role === r.code" class="fa fa-dot-circle-o"></i>
							<i v-else class="fa fa-circle-o"></i>
						</span>
						<span class="role-card-name">{{r.name}}</span>
						<span class="role-edit" v-if="r.code !== 'Manager'" @click.stop="openRoleEdit(r)">
							<i class="fa fa-pencil-square-o"></i> 编辑
						</span>
						<div class="role-modules">
							<template v-if="r.modules.length">
								<span v-for="m in r.modules" :key="m" class="module-tag">{{m}}</span>
							</template>
							<span v-else class="dark4-color">无任何模块权限</span>
						</div>
					</div>
				</div>

				<div class="emp-bottom-btns">
					<Button @click="openCopy"><i class="fa fa-copy"></i> 从其他账套复制</Button>
					<Button @click="openRoleAdd"><i class="fa fa-plus"></i> 新增角色</Button>
				</div>
			</div>
			<div slot="footer">
				<Button @click="showForm = false">取消</Button>
				<Button color="primary" :loading="loading" @click="saveUser">保存</Button>
			</div>
		</Modal>

		<!-- 角色编辑 -->
		<Modal v-model="roleModal.show" :width="900">
			<div slot="header">{{roleModal.id ? '编辑角色' : '新增角色'}}</div>
			<div class="role-edit-form">
				<div class="re-row">
					<div class="re-label">角色名称</div>
					<div class="re-control">
						<input type="text" v-model="roleModal.name" :disabled="roleModal.isBuiltIn" placeholder="如：审核会计">
					</div>
				</div>
				<div class="re-row">
					<div class="re-label">数据范围</div>
					<div class="re-control">
						<label><input type="radio" v-model="roleModal.dataScope" :value="0">全部数据</label>
						<label><input type="radio" v-model="roleModal.dataScope" :value="1">仅本人数据（只能看到自己填制的凭证）</label>
					</div>
				</div>
				<div class="re-row align-top">
					<div class="re-label">功能权限</div>
					<div class="re-control perm-matrix">
						<div v-for="m in tree" :key="m.code" class="mx-module">
							<div class="mx-module-head">
								<label>
									<input type="checkbox" :checked="moduleChecked(m)" @change="toggleModule(m, $event)">{{m.name}}
								</label>
								<span class="mx-all" @click="moduleChecked(m) ? clearModule(m) : selectModule(m)">全选</span>
							</div>
							<div v-for="f in m.funcs" :key="f.code" class="mx-func-row">
								<span class="mx-func-name">
									<input type="checkbox" :checked="funcChecked(m, f)" @change="toggleFunc(m, f, $event)">{{f.name}}
								</span>
								<span class="mx-ops">
									<label v-for="o in f.ops" :key="o.code">
										<input type="checkbox" :value="keyOf(m, f, o)" v-model="checkedPerms">{{o.name}}
									</label>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<Button @click="roleModal.show = false">取消</Button>
				<Button color="primary" @click="saveRole">保存</Button>
			</div>
		</Modal>

		<!-- 从其他账套复制 -->
		<Modal v-model="copyModal.show" :width="440">
			<div slot="header">从其他账套复制角色</div>
			<div class="padding">
				<div class="copy-tip">将源账套的自定义角色复制到当前账套，同名角色自动跳过。</div>
				<Select v-model="copyModal.sourceAsid" :datas="copyModal.sets" keyName="id" titleName="companyName"
						nullOptionText="请选择账套"></Select>
			</div>
			<div slot="footer">
				<Button @click="copyModal.show = false">取消</Button>
				<Button color="primary" :loading="loading" @click="doCopy">确定复制</Button>
			</div>
		</Modal>

		<!-- 未注册手机：短信验证新增 -->
		<Modal v-model="showNewForm" hasCloseIcon>
			<div slot="header">新增权限</div>
			<div v-width="300" class="margin">
				亲，您输入的手机还没有注册，确认需要新增吗？
				为保障您的数据安全，请完成安全验证。
			</div>
			<Row type="flex" :space="10" class="margin">
				<Cell><input type="text" v-model="form.mobile" disabled></Cell>
			</Row>
			<Row type="flex" :space="10" class="margin">
				<Cell>
					<CaptchaVerificationCode ref="newUserCaptcha" v-model="msgCode" :mobile="form.mobile"/>
				</Cell>
			</Row>
			<div class="text-center">
				<Button color="green" @click="addNewUser" :loading="loading">确定</Button>
				<Button @click="showNewForm = false">取消</Button>
			</div>
		</Modal>

		<!-- 移交账套 -->
		<Modal v-model="showHandOver" hasCloseIcon>
			<div slot="header">移交账套</div>
			<div v-width="300" class="margin">
				<template v-if="authenticated">
					请验证接收人的手机，他即将接收的账套是：
				</template>
				<template v-else>
					请验证移交人的手机，您即将移交的账套是：
				</template>
				<br>
				{{currentAccountSets.companyName}}
				<p class="red-color">注意：移交账套后，您将不能再查看该账套！</p>
			</div>
			<div v-show="authenticated">
				<div class="margin h-input-group">
					<input type="text" v-model="receiverMobile" placeholder="请输入接收人手机">
				</div>
				<div class="margin">
					<CaptchaVerificationCode ref="receiverCaptcha" v-model="verificationCode" :mobile="receiverMobile"/>
				</div>
			</div>
			<div v-show="!authenticated">
				<div class="margin h-input-group">
					<input type="text" v-model="User.mobile" disabled>
				</div>
				<div class="margin">
					<CaptchaVerificationCode ref="selfCaptcha" v-model="verificationCode" :mobile="User.mobile"/>
				</div>
			</div>
			<div class="text-center">
				<Button color="red" @click="handOver" :loading="loading">确定</Button>
				<Button @click="showHandOver = false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>

	import {mapState} from 'vuex';
	import CaptchaVerificationCode from "../../components/CaptchaVerificationCode";
	import {TREE, MODULES, modulesOf as treeModulesOf} from '../../js/common/permissionTree';

	const emptyForm = () => ({
		id: null,
		mobile: '',
		role: 'Manager'
	});

	export default {
		name: 'PermissionSetting',
		components: {CaptchaVerificationCode},
		data() {
			return {
				datas: [],
				roles: [],
				form: emptyForm(),
				showForm: false,
				showNewForm: false,
				showHandOver: false,
				loading: false,
				authenticated: false,
				receiverMobile: '',
				msgCode: '',
				verificationCode: '',
				tree: TREE,
				checkedPerms: [],
				roleModal: {
					show: false,
					id: null,
					name: '',
					dataScope: 0,
					isBuiltIn: false
				},
				copyModal: {
					show: false,
					sets: [],
					sourceAsid: null
				}
			};
		},
		computed: {
			...mapState(['currentAccountSets', 'User']),
			/**
			 * 员工自动补全候选：当前账套已有成员
			 */
			employeeCandidates() {
				return this.datas.map(u => ({
					id: u.id,
					mobile: u.mobile,
					realName: u.realName
				}));
			},
			roleCards() {
				return this.roles.map(r => ({
					id: r.id,
					code: r.code,
					name: r.name,
					builtIn: r.builtIn,
					modules: r.code === 'Manager' ? MODULES.slice() : this.modulesOf(r.permissions)
				}));
			}
		},
		methods: {
			loadList() {
				this.$api.setting.user.list().then(({data}) => {
					this.datas = data || [];
				});
			},
			loadRoles(selectCode) {
				return this.$api.setting.role.list().then(({data}) => {
					this.roles = data || [];
					if (selectCode) {
						this.form.role = selectCode;
					}
				});
			},
			roleName(code) {
				let r = this.roles.find(item => item.code === code);
				return r ? r.name : code;
			},
			parsePerms(json) {
				try {
					return json ? JSON.parse(json) : [];
				} catch (e) {
					return [];
				}
			},
			modulesOf(json) {
				return treeModulesOf(this.parsePerms(json));
			},

			openAdd() {
				this.form = emptyForm();
				this.showForm = true;
			},
			edit(data) {
				this.form = {
					id: data.id,
					role: data.role,
					mobile: data.mobile
				};
				this.showForm = true;
			},
			saveUser() {
				if (!/^1\d{10}$/.test(this.form.mobile)) {
					this.$Message('请输入正确的11位手机号码');
					return;
				}
				this.loading = true;
				this.$api.setting.accountSets[this.form.id ? 'updateUserRole' : 'addUser'](this.form).then(() => {
					this.loadList();
					this.showForm = false;
					this.loading = false;
				}).catch((rs) => {
					this.loading = false;
					if (rs.code == 501) {
						this.showNewForm = true;
					}
				});
			},
			addNewUser() {
				if (!this.msgCode) {
					this.$Message('请输入验证码！');
					return;
				}
				this.loading = true;
				this.$api.setting.accountSets.addNewUser(Object.assign({}, this.form, {code: this.msgCode})).then(() => {
					this.loadList();
					this.showForm = false;
					this.showNewForm = false;
					this.loading = false;
				}).catch(() => {
					this.loading = false;
					this.$refs.newUserCaptcha && this.$refs.newUserCaptcha.clear();
				});
			},
			remove(data) {
				this.$Confirm("确认删除该成员的账套权限?").then(() => {
					this.$api.setting.accountSets.removeUser(data.id).then(() => {
						this.loadList();
					});
				});
			},

			/* ===== 角色编辑 ===== */
			openRoleAdd() {
				this.roleModal = {
					show: true,
					id: null,
					name: '',
					dataScope: 0,
					isBuiltIn: false
				};
				this.checkedPerms = [];
			},
			openRoleEdit(card) {
				let role = this.roles.find(r => r.code === card.code);
				this.roleModal = {
					show: true,
					id: role.id,
					name: role.name,
					dataScope: role.dataScope == null ? 0 : role.dataScope,
					isBuiltIn: role.builtIn === 1
				};
				this.checkedPerms = this.parsePerms(role.permissions);
			},
			keyOf(m, f, o) {
				return `${m.code}.${f.code}.${o.code}`;
			},
			funcKeys(m, f) {
				return f.ops.map(o => this.keyOf(m, f, o));
			},
			moduleKeys(m) {
				let keys = [];
				m.funcs.forEach(f => {
					keys = keys.concat(this.funcKeys(m, f));
				});
				return keys;
			},
			funcChecked(m, f) {
				return this.funcKeys(m, f).every(k => this.checkedPerms.indexOf(k) > -1);
			},
			moduleChecked(m) {
				return this.moduleKeys(m).every(k => this.checkedPerms.indexOf(k) > -1);
			},
			toggleFunc(m, f, e) {
				if (e.target.checked) {
					this.selectKeys(this.funcKeys(m, f));
				} else {
					this.removeKeys(this.funcKeys(m, f));
				}
			},
			toggleModule(m, e) {
				if (e.target.checked) {
					this.selectKeys(this.moduleKeys(m));
				} else {
					this.removeKeys(this.moduleKeys(m));
				}
			},
			selectModule(m) {
				this.selectKeys(this.moduleKeys(m));
			},
			clearModule(m) {
				this.removeKeys(this.moduleKeys(m));
			},
			selectKeys(keys) {
				keys.forEach(k => {
					if (this.checkedPerms.indexOf(k) === -1) {
						this.checkedPerms.push(k);
					}
				});
			},
			removeKeys(keys) {
				this.checkedPerms = this.checkedPerms.filter(k => keys.indexOf(k) === -1);
			},
			saveRole() {
				if (!this.roleModal.isBuiltIn && !(this.roleModal.name || '').trim()) {
					this.$Message('请输入角色名称');
					return;
				}
				let params = {
					id: this.roleModal.id,
					name: (this.roleModal.name || '').trim(),
					dataScope: this.roleModal.dataScope,
					permissions: JSON.stringify(this.checkedPerms)
				};
				let request = this.roleModal.id
					? this.$api.setting.role.update(params)
					: this.$api.setting.role.save(params);
				request.then(({data}) => {
					this.$Message('角色保存成功');
					this.roleModal.show = false;
					let selectedCode = this.roleModal.id ? this.form.role : (data && data.code);
					this.loadRoles(selectedCode);
				});
			},

			/* ===== 从其他账套复制 ===== */
			openCopy() {
				this.copyModal = {show: true, sets: [], sourceAsid: null};
				this.$api.setting.accountSets.list().then(({data}) => {
					let list = data && (data.results || data.records) ? (data.results || data.records) : data;
					this.copyModal.sets = (list || []).filter(s => s.id !== this.currentAccountSets.id);
				});
			},
			doCopy() {
				if (!this.copyModal.sourceAsid) {
					this.$Message('请选择源账套');
					return;
				}
				this.loading = true;
				this.$api.setting.role.copy(this.copyModal.sourceAsid).then(({data}) => {
					this.$Message(data > 0 ? `已复制 ${data} 个角色` : '没有可复制的新角色（同名已跳过）');
					this.copyModal.show = false;
					this.loadRoles();
				}).finally(() => {
					this.loading = false;
				});
			},

			handOver() {
				if (this.verificationCode) {
					if (!this.authenticated) {
						//移交人身份确认
						this.$api.setting.accountSets.identification({code: this.verificationCode}).then(() => {
							this.verificationCode = "";
							this.authenticated = true;
						}).catch(() => {
							this.$refs.selfCaptcha && this.$refs.selfCaptcha.clear();
						});
					} else {
						this.$api.setting.accountSets.handOver({
							mobile: this.receiverMobile,
							code: this.verificationCode
						}).then(() => {
							window.location.replace("/");
						}).catch(() => {
							this.$refs.receiverCaptcha && this.$refs.receiverCaptcha.clear();
						});
					}
				}
			}
		},
		mounted() {
			this.loadList();
			this.loadRoles();
		}
	};
</script>

<style lang="less">
	.emp-form {
		padding: 5px 20px 0;

		.emp-label {
			font-weight: bold;
			margin-bottom: 8px;

			&.emp-role-label {
				margin: 20px 0 10px;
			}
		}

		.emp-input {
			width: 100%;
			height: 34px;
			padding: 4px 10px;
			border: 1px solid #d9d9d9;
			border-radius: 4px;
		}

		.role-cards {
			.role-card {
				position: relative;
				padding: 10px 14px;
				border: 1px solid #e8e8e8;
				border-radius: 4px;
				margin-bottom: 10px;
				cursor: pointer;
				transition: all 0.2s;

				&:hover {
					border-color: #b8d4ff;
				}

				&.role-card-on {
					border-color: #2d8cf0;
					background: #f0f7ff;
				}

				.role-radio {
					color: #2d8cf0;
					margin-right: 8px;

					.fa-circle-o {
						color: #bfbfbf;
					}
				}

				.role-card-name {
					font-weight: bold;
				}

				.role-edit {
					margin-left: 12px;
					color: #2d8cf0;
					font-size: 12px;
				}

				.role-modules {
					padding: 6px 0 0 26px;

					.module-tag {
						color: #595959;

						&:after {
							content: ' |';
							color: #d9d9d9;
						}

						&:last-child:after {
							content: '';
						}
					}
				}
			}
		}

		.emp-bottom-btns {
			margin-top: 14px;

			button {
				margin-right: 10px;
			}
		}
	}

	.role-edit-form {
		padding: 5px 20px 0;

		.perm-matrix {
			border: 1px solid #e8e8e8;
			border-radius: 4px;
			max-height: 460px;
			overflow-y: auto;

			.mx-module {
				border-bottom: 1px solid #f0f0f0;

				&:last-child {
					border-bottom: none;
				}
			}

			.mx-module-head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 8px 12px;
				background: #fafafa;

				label {
					font-weight: bold;
					margin: 0;
				}

				.mx-all {
					color: #2d8cf0;
					font-size: 12px;
					cursor: pointer;
					font-weight: normal;
				}
			}

			.mx-func-row {
				display: flex;
				align-items: center;
				padding: 6px 12px 6px 20px;

				.mx-func-name {
					width: 170px;
					flex-shrink: 0;

					input {
						margin-right: 6px;
					}
				}

				.mx-ops {
					flex: 1;

					label {
						display: inline-block;
						min-width: 78px;
						margin: 0 10px 0 0;
						font-weight: normal;
					}
				}
			}
		}

		.re-row {
			display: flex;
			padding: 8px 0;

			&.align-top {
				align-items: flex-start;
			}

			.re-label {
				width: 80px;
				flex-shrink: 0;
				padding-top: 4px;
				font-weight: bold;
			}

			.re-control {
				flex: 1;

				input[type=text] {
					width: 300px;
					height: 32px;
					padding: 4px 8px;
					border: 1px solid #d9d9d9;
					border-radius: 4px;
				}

				label {
					margin-right: 20px;
				}

				.perm-box {
					border: 1px solid #e8e8e8;
					border-radius: 4px;
					padding: 8px 14px;
					max-height: 340px;
					overflow-y: auto;

					.perm-group {
						padding: 5px 0;

						.perm-group-title {
							font-weight: bold;
						}

						.perm-points {
							padding-left: 24px;

							label {
								display: inline-block;
								width: 150px;
								font-weight: normal;
								padding: 3px 0;
								margin-right: 0;
							}
						}
					}
				}
			}
		}
	}

	.copy-tip {
		color: #8c8c8c;
		font-size: 12px;
		margin-bottom: 10px;
	}
</style>
